import _asyncToGenerator from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/itsasbreuk/Documents/SEC-Token-Interface/node_modules/@babel/runtime/regenerator/index.js";
var getNonce = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(address, web3, withPending) {
    var pending, nonce;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (withPending) {
            pending = 'pending';
          }
          _context.next = 3;
          return web3.eth.getTransactionCount(address, pending);
        case 3:
          nonce = _context.sent;
          return _context.abrupt("return", nonce);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getNonce(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default getNonce;